// import axios from 'axios';
// const domain = window.location.origin;

// axios.defaults.baseURL = domain;
// const request = axios.create({
//   baseURL: `${domain}/w1`,
//   transformResponse: [(response) => {
//     console.log('domain', domain);
//     if (response) {
//       return JSON.parse(response).data;
//     }
//     return null;
//   }],
// });

// export default request;

import axios from 'axios';

const isDev = window.location.hostname === 'localhost';

const request = axios.create({
  baseURL: '/w1',
  withCredentials: true,
  transformResponse: [(response) => {
    if (response) {
      return JSON.parse(response).data;
    }
    return null;
  }],
});

export default request;